import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../api/admin.api';
import { productAPI } from '../../api/product.api';
import Loader from '../../components/common/Loader';

const Dashboard = () => {
  const [stats, setStats] = useState({
    users: 0,
    orders: 0,
    products: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [users, orders, products] = await Promise.all([
        adminAPI.getUsers(),
        adminAPI.getOrders(),
        productAPI.getAll(),
      ]);
      setStats({
        users: users.items?.length || users.users?.length || 0,
        orders: orders.items?.length || orders.orders?.length || 0,
        products: products.items?.length || products.products?.length || products.total || 0,
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div>
      <h1>Admin Dashboard</h1>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginTop: '20px' }}>
        <div style={{ padding: '30px', backgroundColor: 'var(--color-primary)', color: 'var(--color-text)', borderRadius: '8px' }}>
          <h2>{stats.users}</h2>
          <p>Total Users</p>
        </div>
        <div style={{ padding: '30px', backgroundColor: '#cfe8cf', color: 'var(--color-text)', borderRadius: '8px' }}>
          <h2>{stats.orders}</h2>
          <p>Total Orders</p>
        </div>
        <div style={{ padding: '30px', backgroundColor: 'rgba(236, 204, 15, 0.55)', color: 'var(--color-text)', borderRadius: '8px' }}>
          <h2>{stats.products}</h2>
          <p>Total Products</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
